import React from 'react';
import { useTranslation } from 'react-i18next';
import leaderboardEmptyStateIllustration from '../../assets/images/bfg/leaderboard-empty-state-illus.svg';
import { IllustratedCtaCard } from '../illustrated-cta-card';
// Shown above the leaderboard, in place of BfgScoreDetailCard, while the event hasn't started yet
// — the leaderboard itself stays visible (unlike the old full-tab empty state it replaces).
function LeaderboardScoreFutureCard({
  Button,
  selectTab,
  startDate
}) {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(IllustratedCtaCard, {
    Button: Button,
    ctaLabel: t('commons.challenges.leaderboard.future_cta'),
    description: t('commons.challenges.leaderboard.future_description_score'),
    illustration: leaderboardEmptyStateIllustration,
    onCtaClick: () => selectTab('potential'),
    title: t('commons.challenges.leaderboard.future_title', {
      date: startDate.format('D MMMM')
    })
  });
}
export default LeaderboardScoreFutureCard;